/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber8Small = createReactComponent("number-8-small", "IconNumber8Small", [
  [
    "path",
    {
      d: "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1",
      key: "svg-0"
    }
  ]
]);

export { IconNumber8Small as default };
//# sourceMappingURL=IconNumber8Small.js.map
